"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _AlertsContainer = _interopRequireDefault(require("./components/alerts/AlertsContainer"));

var _PulseWidgetWrapper = _interopRequireDefault(require("./PulseWidgetWrapper"));

var _SettingsService = _interopRequireDefault(require("../pulse/service/SettingsService"));

var _store = _interopRequireDefault(require("./store/store"));

var types = _interopRequireWildcard(require("../pulse/store/actions/actionTypes"));

var NotificationSelectors = _interopRequireWildcard(require("../pulse/store/reducers/NotificationReducer"));

var AnnouncementSelectors = _interopRequireWildcard(require("../pulse/store/reducers/AnnouncementReducer"));

var AnnouncementActions = _interopRequireWildcard(require("../pulse/store/actions/actions"));

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

var _MetricsUtil = _interopRequireDefault(require("./util/MetricsUtil"));

var _PulseUtil = _interopRequireDefault(require("./util/PulseUtil"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var unreadNotificationCallback = undefined,
    flyoutOpen = false;

var metrics = function () {
  var instance;
  return function () {
    return instance = instance || _metrics.default.create("exc.pulse.PulseComponent");
  };
}();

_store.default.subscribe(function () {
  var newNotifications = NotificationSelectors.getNewNotifications(_store.default.getState());
  var hasUnseenAnnouncements = AnnouncementSelectors.hasUnseenAnnouncements(_store.default.getState()),
      activeTabIndex = NotificationSelectors.getActiveTabIndex(_store.default.getState());

  if (newNotifications) {
    if (flyoutOpen && activeTabIndex === 0) {
      newNotifications = [];
    }

    unreadNotificationCallback != undefined && unreadNotificationCallback(hasUnseenAnnouncements, newNotifications.length);
  }
});

function flyoutComponent(unreadNotificationsChangeCallback, viewAllClickCallback) {
  unreadNotificationCallback = unreadNotificationsChangeCallback;
  return _react.default.createElement(_PulseWidgetWrapper.default, {
    onViewAllClicked: viewAllClickCallback
  });
}

function alertsContainer() {
  return _react.default.createElement(_AlertsContainer.default, {
    store: _store.default
  });
}
/**
* openDefaultTab() is created for deciding which tab to open when the pulse widget gets opened
* The logic is when new notification is present then it should be default tab to be opened
* and same for announcement
* If both new notification and announcement are present then it will look for last opened tab
* else notification tab
* If no new notification and announcement are present, go for last opened tab
*/


function openDefaultTab() {
  return _openDefaultTab.apply(this, arguments);
}

function _openDefaultTab() {
  _openDefaultTab = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    var newNotifications, tabIndex, activeTabIndex, hasUnseenAnnouncements;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            newNotifications = NotificationSelectors.getNewNotifications(_store.default.getState()), tabIndex = 0;
            activeTabIndex = NotificationSelectors.getActiveTabIndex(_store.default.getState()), hasUnseenAnnouncements = AnnouncementSelectors.hasUnseenAnnouncements(_store.default.getState());

            if (newNotifications.length > 0 && hasUnseenAnnouncements) {
              tabIndex = activeTabIndex === 0 ? 0 : 1;
            } else if (newNotifications.length > 0) {
              tabIndex = 0;
            } else if (hasUnseenAnnouncements) {
              tabIndex = 1;
            } else {
              tabIndex = activeTabIndex;
            }

            _context.next = 5;
            return _store.default.dispatch({
              type: types.ACTIVE_TAB_INDEX_CHANGED,
              payload: tabIndex
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _openDefaultTab.apply(this, arguments);
}

function onFlyoutOpen() {
  return _onFlyoutOpen.apply(this, arguments);
}
/*
* SET_LAST_NOTIFICATION_SEEN_TIMESTAMP is for showing New and Earlier sections.
* The current behaviour is on opening flyout,
* 1) remove the counter from bell icon in unified-shell
* 2) Still group the notifications into new and early
* So onFlyoutOpen, fetching the lastClickTimestamp which is to show counter on bell on unified-shell
* and setting it to SET_LAST_NOTIFICATION_SEEN_TIMESTAMP for new and earlier sections
* and then lastClickTimestamp is reset on opening flyout to remove counter
*/


function _onFlyoutOpen() {
  _onFlyoutOpen = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2() {
    var timeNow;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            openDefaultTab();
            metrics().event("flyout.open");
            flyoutOpen = true;
            AnnouncementActions.onAnnouncementTabMount(false);
            setLastNotificationSeen();
            timeNow = NotificationSelectors.getServerTime(_store.default.getState());
            _context2.next = 8;
            return _store.default.dispatch({
              type: types.SET_LAST_USER_CLICK_TIMESTAMP,
              payload: timeNow
            });

          case 8:
            _context2.next = 10;
            return _store.default.dispatch({
              type: types.SET_FLYOUT_LAST_OPEN_TIMESTAMP,
              payload: timeNow
            });

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _onFlyoutOpen.apply(this, arguments);
}

function setLastNotificationSeen() {
  return _setLastNotificationSeen.apply(this, arguments);
}

function _setLastNotificationSeen() {
  _setLastNotificationSeen = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3() {
    var timeStampVal,
        userSettings,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            timeStampVal = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : null;

            if (!timeStampVal) {
              _context3.next = 6;
              break;
            }

            _context3.next = 4;
            return _store.default.dispatch({
              type: types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP,
              payload: timeStampVal
            });

          case 4:
            _context3.next = 13;
            break;

          case 6:
            _context3.next = 8;
            return (0, _SettingsService.default)().getUserSettings();

          case 8:
            userSettings = _context3.sent;
            _context3.t0 = userSettings && userSettings.lastClickTimestamp;

            if (!_context3.t0) {
              _context3.next = 13;
              break;
            }

            _context3.next = 13;
            return _store.default.dispatch({
              type: types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP,
              payload: userSettings.lastClickTimestamp
            });

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _setLastNotificationSeen.apply(this, arguments);
}

function onFlyoutClose() {
  return _onFlyoutClose.apply(this, arguments);
}

function _onFlyoutClose() {
  _onFlyoutClose = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee4() {
    var activeTabIndex, timeNow;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            metrics().event("flyout.close");
            flyoutOpen = false;
            activeTabIndex = NotificationSelectors.getActiveTabIndex(_store.default.getState());

            if (activeTabIndex === 1) {
              AnnouncementActions.onAnnouncementTabUnmount();
            }

            timeNow = NotificationSelectors.getServerTime(_store.default.getState());
            setLastNotificationSeen(timeNow);

            _store.default.dispatch({
              type: types.SET_LAST_USER_CLICK_TIMESTAMP,
              payload: timeNow
            });

            _store.default.dispatch({
              type: types.SET_FLYOUT_LAST_CLOSE_TIMESTAMP,
              payload: timeNow
            });

            _context4.next = 10;
            return (0, _SettingsService.default)().updateUserSettings({
              lastClickTimestamp: timeNow
            });

          case 10:
            _context4.next = 12;
            return (0, _SettingsService.default)().updateUserSettings({
              lastNotificationSeenTimestamp: timeNow
            });

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _onFlyoutClose.apply(this, arguments);
}

var _default = {
  flyoutComponent: flyoutComponent,
  alertsContainer: alertsContainer,
  onFlyoutOpen: onFlyoutOpen,
  onFlyoutClose: onFlyoutClose
};
exports.default = _default;